import { Component, Input } from '@angular/core';

import { ProductTag } from 'projects/shared/lib/components/shared/product/tag/product-tag.model';

@Component({
    selector: 'app-product-tag-pictogram',
    imports: [],
    templateUrl: './product-tag-pictogram.component.html',
    styleUrls: ['./product-tag-pictogram.component.scss']
})
export class ProductTagPictogramComponent {
  @Input() public productTagList! : ProductTag[];
}
